import service from "@/utils/service.js"
import { addApiPathFor } from "./utils.js"

// 心跳测试接口
export const apiTest = () => {
  return service({
    url: addApiPathFor("/heartbeat"),
    method: "get"
  })
}

// 登录接口
export const login = data => {
  return service({
    url: addApiPathFor("/auth/login"),
    method: "post",
    data
  })
}

// Okta登录接口 - 获取登录页面
export const loginOkta = () => {
  return service({
    url: addApiPathFor("/auth/oktaLogin"),
    method: "post"
  })
}

// Okta登录成功后回调接口
export const callbackOkta = data => {
  return service({
    url: addApiPathFor("/auth/oktaCallback"),
    method: "post",
    data
  })
}

// AD登录接口 - 获取登录页面
export const loginAD = () => {
  return service({
    url: addApiPathFor("/auth/azureADLogin"),
    method: "post"
  })
}

// Okta登录成功后回调接口
export const callbackAD = data => {
  return service({
    url: addApiPathFor("/auth/azureADCallback"),
    method: "post",
    data
  })
}

// 注册
export const register = data => {
  return service({
    url: addApiPathFor("/register"),
    method: "post",
    data
  })
}

// 高权限注册
export const manageRegister = data => {
  return service({
    url: addApiPathFor("/management/register"),
    method: "post",
    data
  })
}

// 删除一个账号
export const fetchDeleteAccount = data => {
  return service({
    url: addApiPathFor("/management/delete"),
    method: "post",
    data
  })
}

export const logout = data => {
  return service({
    url: "/api/auth/logout",
    method: "post",
    data,
    loading: 0
  })
}



// WEBPACK FOOTER //
// ./src/api/auth.js